import { FormReviewData } from "@/types";

interface MedicationsSectionProps {
  formData: FormReviewData;
}

export function MedicationsSection({ formData }: MedicationsSectionProps) {
  const medications = formData?.formData?.medications || {};

  if (!(medications as any).medication_list) {
    return null;
  }

  return (
    <div className="info-card medications-section">
      <h3>Medications</h3>
      <div
        className="medications-grid"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        <div
          className="medication-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 items-start"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Medication List:
          </label>
          <span style={{ color: "#1f2937" }}>
            {(medications as any).medication_list}
          </span>
        </div>
      </div>
    </div>
  );
}
